var _polygon, _path, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path0, _path1, _path10, _path11, _rect, _ellipse, _ellipse2, _line, _circle2, _rect2, _rect3, _line2, _circle3, _path12, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle4, _path13, _rect0, _rect1, _line3, _line4, _line5, _line6, _rect10, _polygon3, _circle5, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAppContentEmptyState = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aff71ab5-257b-4a41-8490-967d8a55fbdf",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 830.3448,
    height: 665.26174,
    viewBox: "0 0 830.3448 665.26174",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "insert block") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "222.243 506.623 284.413 408.854 145.18 320.317 73.276 433.392 188.44 506.623 222.243 506.623",
    fill: "#f0f0f0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M872.19482,260.38616a1.90166,1.90166,0,0,1-2.22908-.921c-1.79189-2.82326,1.5072-6.46369.79284-9.7304-.5723-2.61711-3.5462-4.17044-4.15424-6.77948-.59082-2.53511,1.2297-5.39262-.00079-7.68647-.964-1.79711-3.37206-2.27-5.387-1.95519s-3.92737,1.20057-5.96294,1.32468c-2.71243.16537-5.298-1.02868-7.95031-1.62029s-5.88745-.36-7.44774,1.8649c-2.00344,2.85679.02884,6.83476-.66875,10.25359-.55394,2.71477-2.82663,4.96268-2.87546,7.733-.01736.98464,2.57111.19143,2.43353,1.16656s1.08583.11653.10788.00069a1.937,1.937,0,0,1-1.47175-1.75052c-.11628-.8122-1.6426-1.08294-1.625-1.90322.04127-1.92244-3.4344-.62623-4.00679-2.46194a18.61546,18.61546,0,0,1,.76076-12.98628,26.00908,26.00908,0,0,0,2.2171-5.28133c.5106-2.549-.2928-5.28535.54934-7.74479,1.13489-3.31445,4.8903-5.00406,8.37681-5.34722s7.02955.2711,10.49617-.23493c3.10551-.45332,6.112-1.79923,9.24433-1.60422,3.75853.234,7.0292,2.65567,9.63456,5.37475s4.81548,5.84644,7.77442,8.17581a15.24768,15.24768,0,0,1,2.49281,2.146c1.50708,1.83657,1.65994,4.45286,1.2407,6.79135s-1.3315,4.56913-1.71669,6.91347c-.362,2.20312-.25031,4.454-.40622,6.68118a11.74356,11.74356,0,0,1-1.9596,6.30669,5.95207,5.95207,0,0,1-4.63157,2.41972c-.62716.01446-1.15686-.54908-1.78985-.40213C873.24113,259.3128,872.89709,260.06418,872.19482,260.38616Z",
    transform: "translate(-184.8276 -117.36913)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "714.193 304.873 711.868 319.154 707.219 312.844 709.875 303.213 714.193 304.873",
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M896.03145,314.31139l3.66053,9.64643s3.64558,49.13453,3.64558,52.78758-2.65677,50.47857-3.65306,52.47114c0,0-4.31724-6.30982-9.96287-5.31353s-3.321-16.60479-3.321-16.60479l-5.31353-43.50455.99628-21.91833Z",
    transform: "translate(-184.8276 -117.36913)",
    fill: "#575a89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M896.03145,314.31139l3.66053,9.64643s3.64558,49.13453,3.64558,52.78758-2.65677,50.47857-3.65306,52.47114c0,0-4.31724-6.30982-9.96287-5.31353s-3.321-16.60479-3.321-16.60479l-5.31353-43.50455.99628-21.91833Z",
    transform: "translate(-184.8276 -117.36913)",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M873.44893,261.17606s-10.95916,27.89605-4.64934,33.20958-35.20216-8.96658-35.20216-8.96658l.99629-3.65306s13.61593-5.31353,6.974-20.58994S873.44893,261.17606,873.44893,261.17606Z",
    transform: "translate(-184.8276 -117.36913)",
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M873.44893,261.17606s-10.95916,27.89605-4.64934,33.20958-35.20216-8.96658-35.20216-8.96658l.99629-3.65306s13.61593-5.31353,6.974-20.58994S873.44893,261.17606,873.44893,261.17606Z",
    transform: "translate(-184.8276 -117.36913)",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M890.71791,633.78757s4.64935-1.32839,7.30611,1.99257,12.61964,11.62336,12.61964,11.62336,19.26156-1.99258,21.91833,7.6382-30.22072,9.63078-38.191,7.30611-9.63078,0-9.63078,0-24.57509,1.99257-24.57509-1.99258,2.32467-17.60108,2.32467-17.60108Z",
    transform: "translate(-184.8276 -117.36913)",
    fill: "#575a89"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M812.6754,656.038l4.31724,13.28383s12.95174,17.93317,5.64563,21.58623-33.20958,7.3061-33.20958-2.32467V670.31811s2.65677-12.95174,5.31353-14.28012S812.6754,656.038,812.6754,656.038Z",
    transform: "translate(-184.8276 -117.36913)",
    fill: "#575a89"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M886.01487,417.38322s14.00173,12.16542,13.66963,13.8259-6.974,108.26323-6.974,108.26323l-3.65305,69.07593s4.64934,16.2727,2.32467,19.92575,3.321,4.64934,3.321,4.64934-23.91089,21.58623-33.87377,12.28755l-9.29868-120.55078-25.57138,87.67329s-4.31725,46.49342-9.29868,46.49342-25.23928.99629-24.90719-1.66048-.99629-22.91461,1.32838-34.87006,17.93318-106.60276,17.93318-106.60276,1.34188-81.13946-2.15188-88.72362,1.81978-15.55446,1.81978-15.55446l23.24671-8.96659,27.896,3.321Z",
    transform: "translate(-184.8276 -117.36913)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 673.01283,
    cy: 131.85148,
    r: 23.24671,
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M801.38414,299.36708a20.85274,20.85274,0,0,1,14.61222-13.28383A128.80878,128.80878,0,0,0,835.59,279.44133s23.5788,11.29126,28.22814,11.29126,4.64935-2.98886,4.64935-2.98886,11.95544,12.61964,18.26527,13.948,15.6085,16.93689,12.28754,25.57138a48.18834,48.18834,0,0,1-9.63078,14.94431s1.32838,46.49341-2.98886,55.12791c0,0,10.62707,20.25784.66419,21.58622S838.911,415.60062,832.26905,420.25s-18.92946-.99629-20.58994,5.31353-5.31353,7.6382-5.31353,7.6382-5.64563-8.96658-2.32467-14.28012S801.38414,299.36708,801.38414,299.36708Z",
    transform: "translate(-184.8276 -117.36913)",
    fill: "#575a89"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M825.95923,424.23511l5.31353,3.32095s-5.64563,19.59366-7.9703,20.25785-7.79655-16.75374-7.79655-16.75374Z",
    transform: "translate(-184.8276 -117.36913)",
    fill: "#a0616a"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M876.18,258.06149a1.90167,1.90167,0,0,1-2.22908-.921c-1.79189-2.82326,1.5072-6.4637.79284-9.7304-.5723-2.61711-3.5462-4.17044-4.15424-6.77948-.59082-2.53511,1.2297-5.39262-.00079-7.68647-.964-1.79711-3.37206-2.27-5.387-1.9552s-3.92737,1.20058-5.96294,1.32469c-2.71243.16537-5.298-1.02868-7.95031-1.62029s-5.88745-.36-7.44774,1.8649c-2.00344,2.85678.02884,6.83476-.66875,10.25359-.55394,2.71477-6.86519,4.62025-7.43758,2.78454a18.61546,18.61546,0,0,1,.76076-12.98628,26.00908,26.00908,0,0,0,2.2171-5.28133c.5106-2.549-.2928-5.28535.54934-7.74479,1.13489-3.31445,4.8903-5.00406,8.37681-5.34722s7.02955.2711,10.49617-.23493c3.10551-.45332,6.112-1.79923,9.24433-1.60422,3.75853.234,7.02919,2.65567,9.63456,5.37475s4.81548,5.84644,7.77442,8.17581a15.24768,15.24768,0,0,1,2.49281,2.146c1.50708,1.83656,1.65994,4.45286,1.2407,6.79135s-1.3315,4.56913-1.71669,6.91346c-.362,2.20313-.25031,4.454-.40622,6.68119a11.74356,11.74356,0,0,1-1.9596,6.30669,5.95207,5.95207,0,0,1-4.63157,2.41972c-.62716.01446-1.15686-.54908-1.78985-.40213C877.22628,256.98813,876.88224,257.7395,876.18,258.06149Z",
    transform: "translate(-184.8276 -117.36913)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M814.50192,305.17876l-10.79311-5.81168s-26.23557,62.434-19.92575,79.703,30.55282,52.80323,30.55282,52.80323,19.26155-3.98515,17.269-7.9703-14.94431-29.55653-15.9406-32.87749-7.6382-24.90718-4.64934-27.23185,8.80054-56.29024,8.80054-56.29024Z",
    transform: "translate(-184.8276 -117.36913)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M814.668,295.714l-13.28383,3.65305s-26.23557,62.434-19.92575,79.703,30.55282,52.80323,30.55282,52.80323,19.26155-3.98515,17.269-7.9703-14.94431-29.55653-15.9406-32.87749-7.6382-24.90718-4.64934-27.23185,17.269-59.77725,17.269-59.77725Z",
    transform: "translate(-184.8276 -117.36913)",
    fill: "#575a89"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 700.40456,
    y: 245.80861,
    width: 52,
    height: 52,
    transform: "translate(106.59329 -487.6919) rotate(35.37103)",
    fill: "#f0f0f0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.97354,
    cy: 653.24709,
    rx: 182.62275,
    ry: 12.01465,
    fill: "#f2f2f2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.72205,
    cy: 603.66625,
    rx: 182.62275,
    ry: 12.01465,
    fill: "#f2f2f2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.3448,
    y1: 579.62296,
    x2: 645.24301,
    y2: 579.70218,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 574.3448,
    cy: 224.62296,
    r: 11,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 131.3448,
    y: 66.62296,
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 162.3448,
    y: 401.62296,
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32.32009,
    y1: 581.50672,
    x2: 32.32009,
    y2: 507.09534,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.32009,
    cy: 507.09534,
    r: 10.52282,
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M217.14769,670.32574s-1.50326-32.33193-32.32009-28.57378",
    transform: "translate(-184.8276 -117.36913)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 505.14893,
    y: 131.47415,
    width: 8.52117,
    height: 70.25619,
    rx: 2.29166,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 221.86346,
    y: 76.43434,
    width: 4.78229,
    height: 23.12889,
    rx: 1.50327,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 221.68955,
    y: 118.77934,
    width: 5.39095,
    height: 40.25819,
    rx: 1.6946,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 221.77651,
    y: 173.12355,
    width: 5.13009,
    height: 40.60599,
    rx: 1.6126,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 224.57206,
    width: 285.17603,
    height: 579.57834,
    rx: 35.69395,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 339.65104,
    y: 17.30784,
    width: 39.82343,
    height: 8.08642,
    rx: 2.54189,
    fill: "#e6e8ec"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 390.08246,
    cy: 21.35105,
    r: 4.58665,
    fill: "#e6e8ec"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M676.9649,155.11667v504.0884A22.64644,22.64644,0,0,1,654.3147,681.847H449.66155a22.64644,22.64644,0,0,1-22.65021-22.64188V155.11667a22.64823,22.64823,0,0,1,22.65021-22.65021H480.286v3.93342a18.656,18.656,0,0,0,18.65067,18.65067H603.01509a18.6507,18.6507,0,0,0,18.65062-18.65067v-3.93342h32.649A22.64822,22.64822,0,0,1,676.9649,155.11667Z",
    transform: "translate(-184.8276 -117.36913)",
    fill: "#fff"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 241.98552,
    y: 99.59439,
    width: 250.38323,
    height: 171.88024,
    fill: "#ccc",
    opacity: 0.3
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 241.98552,
    y: 327.66625,
    width: 250.38323,
    height: 171.88024,
    fill: "#ccc",
    opacity: 0.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 241.98552,
    y1: 99.59439,
    x2: 492.36875,
    y2: 271.47463,
    fill: "none",
    stroke: "#ff5722",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 492.36875,
    y1: 99.59439,
    x2: 241.98552,
    y2: 271.47463,
    fill: "none",
    stroke: "#ff5722",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 241.98552,
    y1: 327.66625,
    x2: 492.36875,
    y2: 499.54649,
    fill: "none",
    stroke: "#ff5722",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 492.36875,
    y1: 327.66625,
    x2: 241.98552,
    y2: 499.54649,
    fill: "none",
    stroke: "#ff5722",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 532.03342,
    y: 431.78601,
    width: 250.38323,
    height: 171.88024,
    fill: "#ff5722"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "782.417 603.666 729.347 499.996 711.351 549.127 647.722 455.75 605.578 513.594 585.089 488.922 532.033 554.515 532.033 603.666 782.417 603.666",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.84181,
    cy: 471.45068,
    r: 18.17964,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 73.41067,
    y: 479.71415,
    width: 250.38323,
    height: 171.88024,
    fill: "#ff5722"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 93.65618,
    y: 517.72613,
    width: 209.89222,
    height: 9.91617,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 93.65618,
    y: 539.21116,
    width: 209.89222,
    height: 9.91617,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 93.65618,
    y: 560.69619,
    width: 209.89222,
    height: 9.91617,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 93.65618,
    y: 582.18122,
    width: 209.89222,
    height: 9.91617,
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 93.65618,
    y: 603.66625,
    width: 209.89222,
    height: 9.91617,
    fill: "#3f3d56"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAppContentEmptyState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/app-content-empty-state.14670c6c7acebf5ce325aa48f2820b00.svg";